import { Grid } from "@mui/material";
import { TalentDetails } from "./TalentDetails";
import { JobApplications } from "./jobApplications/JobApplications";
import Employment from "./Employment/Employment";
import EntriesPage from "../entries/EntriesPage";
import { PoolProPage } from "./PoolProPage";
import { Talent, talentIsDeactivated } from "../talents/talentAPI";
import TalentSelfServiceOrderPermissions from "./talentSelfServiceOrderPermissions/TalentSelfServiceOrderPermissions";
import TalentCalendar from "./calendar/TalentCalendar";

type Props = {
  talent: Talent;
  tabIndex: number;
};

const TalentProfileTabPanels = ({ tabIndex, talent }: Props) => {
  const isReadOnly = talentIsDeactivated(talent);
  return (
    <Grid item xs={12}>
      {tabIndex === 0 && <TalentDetails talent={talent} />}
      {tabIndex === 1 && <JobApplications talentId={talent.id} />}
      {tabIndex === 2 && <Employment talent={talent} />}
      {tabIndex === 3 && (
        <EntriesPage
          newEntryTalentData={{
            id: talent?.id,
            firstName: talent?.account?.firstName,
            lastName: talent?.account?.lastName,
          }}
          isReadOnly={isReadOnly}
        />
      )}
      {tabIndex === 4 && <TalentCalendar talentId={talent.id} />}
      {tabIndex === 5 && <PoolProPage isReadOnly={isReadOnly} />}
      {tabIndex === 6 && <TalentSelfServiceOrderPermissions />}
    </Grid>
  );
};

export default TalentProfileTabPanels;
